
import GaugeChart from "@/components/shared/GaugeChart";

export default {
    name: "ShareGradeSummary",

    components: {
        GaugeChart,
    },

    props: {
        gradeData: {
            type: Object,
            default: () => {},
        }
    },

    computed: {
        gradeText() {
            switch(this.gradeData?.Consensus) {
                case 'Strong Buy':
                    return this.$t('component.share.gradeSummary.strongBuy');
                case 'Buy':
                    return this.$t('component.share.gradeSummary.buy');
                case 'Hold':
                    return this.$t('component.share.gradeSummary.hold');
                case 'Sell':
                    return this.$t('component.share.gradeSummary.sell');
                case 'Strong Sell':
                    return this.$t('component.share.gradeSummary.strongSell');
                default:
                    return this.gradeData?.Consensus ?? '';
            }
        },
        gradeScore() {
            switch(this.gradeData?.Consensus) {
                case 'Strong Buy':
                    return 90;
                case 'Buy':
                    return 71;
                case 'Hold':
                    return 50;
                case 'Sell':
                    return 29;
                case 'Strong Sell':
                    return 10;
                default:
                    return this.gradeData?.Consensus ?? 0;
            }
        },
        totalScore() {
            return (this.gradeData?.strongBuy ?? 0) + (this.gradeData?.buy ?? 0) + (this.gradeData?.hold ?? 0) + (this.gradeData?.sell ?? 0) + (this.gradeData?.strongSell ?? 0);
        }
    },
}
